export class GoogleMapSearchResult
{
    fullAddress: string;
    country:string;
    countryCode: string;
    address: string;
    streetNumber: string;
    postalCode: string;
    state: string;
    city: string;
    lat: number;
    lng: number;
    
}